import { useMemo } from 'react';
import { VisibilityState } from '@tanstack/react-table';
import { PORTFOLIO_METRICS_TABLE_COLUMNS } from '@/enums/Portfolio';

/**
 * Hook to manage column visibility based on user permissions and available holdings
 * @param canViewAltsColumns Boolean flag indicating if alternative columns should be visible
 * @returns Column visibility state object for Tanstack Table
 */
export const useMetricsTableColumnVisibility = (canViewAltsColumns: boolean): VisibilityState =>
  useMemo(() => {
    const visibilityState: VisibilityState = {
      [PORTFOLIO_METRICS_TABLE_COLUMNS.FIRM_NAME]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.VINTAGE]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.STATUS]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.COMMITMENT]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.GP_COMMITMENTS_TO_FUND]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.CALLED]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.DISTRIBUTED]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.REMAINING]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.DURING_INVESTMENT_PERIOD]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.POST_INVESTMENT_PERIOD]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.CHARGE_FREQUENCY]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.HURDLE_RATE]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.CARRIED_INTEREST]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.GP_CATCH_UP_RATE]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.FUND_FORMATION_COST]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.NET_IRR]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.MEDIAN_BENCHMARK_IRR]: canViewAltsColumns,
      [PORTFOLIO_METRICS_TABLE_COLUMNS.QUARTILE]: canViewAltsColumns,
    };

    return visibilityState;
  }, [canViewAltsColumns]);
